import React from "react";
import Sidebar from "../page/Sidebar";
import Content from "../page/Content";
// Import other components as needed

const Body = () => {
  return (
    <div className="text-blue-900 flex flex-row w-screen h-full">
      <Sidebar />
      <Content />
    </div>
  );
};

export default Body;
